import {
  // EditOutlined,
  // DeleteOutlined,
  LoadingOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import { Switch, TableColumnsType } from "antd";
import moment from "moment";
import { ICountry, IJobGrade, IVersion } from "@types";
import { checkPermission } from "@utils";
import { permissions } from "@router";
import { dateFormat, roles } from "@constants";
import { BsTrash3 } from "react-icons/bs";
import { GoPencil } from "react-icons/go";
import { MdOutlineFileDownload } from "react-icons/md";

export const getColumns = ({
  deleteJobGrade,
  jobGrade_id,
  isDeleting,
  editJobGrade,
  userRole,
}: {
  isDeleting: boolean;
  deleteJobGrade: (id: number) => Promise<void>;
  jobGrade_id: React.MutableRefObject<any>;
  editJobGrade: (jobGrade: IJobGrade) => void;
  userRole: string;
}): TableColumnsType<any> => [
    {
      title: "grade",
      dataIndex: "grade",
      key: "grade",
      width: "15%",
      sorter: true,
      align: "center",
      render: (grade: IJobGrade) => {
        return grade || "";
      },
    },
    {
      title: "type",
      dataIndex: "type",
      key: "type",
      width: "20%",
      sorter: true,
      align: "center",

    },
    {
      title: "Countries",
      key: "countries",
      width: "40%",
      sorter: true,
      align: "center",

      render: (jobGrade: IJobGrade, record: IJobGrade & { userRole: string }) => {
        const isOnlyCompanyUser = roles.onlyCompany.includes(userRole);
        // Always show countries list for onlyCompany users
        if (isOnlyCompanyUser) {
          return (
            <div>
              {jobGrade?.countries?.map(({ name }) => name).join(", ") || "—1"}
            </div>
          );
        }

        // For non-onlyCompany users, show countries if not global
        if (!jobGrade?.is_global) {
          return (
            <div>
              {jobGrade?.countries?.map(({ name }) => name).join(", ") || "—2"}
            </div>
          );
        }

        // Otherwise, restrict view (e.g., for global entries to non-onlyCompany users)
        return <div>Global</div>; // or "Restricted" or empty string
      },
    },

    ...(!checkPermission([
      permissions.DELETE_JOB_GRADE,
      permissions.UPDATE_JOB_GRADE,
    ])
      ? []
      : ([
        {
          title: "Actions",
          key: "actions",
          width: "20%  ",
          fixed: "center",
          align: "center",
          render: (jobGrade: IJobGrade) => (
            <div className="flex items-center gap-2">
              {checkPermission(permissions.UPDATE_JOB_GRADE) && (
                <div
                  onClick={() => editJobGrade(jobGrade)}
                  className="table__action__btn table__action__btn--client"
                  style={{ marginRight: "0px" }}
                >
                  <GoPencil className="text-white mr-1 text-sm" /> Edit
                </div>
              )}
              {checkPermission(permissions.DELETE_JOB_GRADE) && (
                <div
                  onClick={() => deleteJobGrade(jobGrade?.id!)}
                  className="table__action__btn table__action__btn--delete"
                  style={{ marginRight: "0px" }}
                >
                  {isDeleting && jobGrade?.id === jobGrade_id?.current ? (
                    <LoadingOutlined color="#B62424" className="spinner" />
                  ) : (
                    <>
                      <BsTrash3 className="text-white textx mr-1" /> Delete
                    </>
                  )}
                </div>
              )}
            </div>
          ),
        },
      ] as any)),
  ];

export const getVersionsColumns = ({
  handleActive,
  versionId,
  download,
  isDownloading,
  downloadingVersionId,
}: {
  handleActive: (id: number) => Promise<void>;
  versionId: number | null;
  download: (id?: number) => Promise<void>;
  isDownloading: boolean;
  downloadingVersionId: MutableRefObject<number | null>;
}): TableColumnsType<any> => [
    {
      title: "created at",
      dataIndex: "created_at",
      key: "created_at",
      width: 240,
      align: "center",
      render: (date: string) => (
        <div>{moment(date).format(dateFormat)}</div>
      ),
    },
    {
      title: "updated at",
      dataIndex: "updated_at",
      key: "updated_at",
      width: 240,
      align: "center",
      render: (date: string) => (
        <div>{moment(date).format(dateFormat)}</div>
      ),
    },

    ...(!checkPermission(permissions.CREATE_JOB_GRADE)
      ? []
      : ([
        {
          title: "Active",
          key: "active",
          width: 140,
          align: "center",
          render: (version: IVersion) => (
            <Switch
              onChange={checked => {
                if (!checked) return;
                handleActive(version?.id);
              }}
              checked={versionId === version?.id}
              defaultChecked={version?.is_active === "TRUE"}
            />
          ),
        },
      ] as any)),

    {
      title: "",
      key: "spacer",
    },

    {
      title: "Actions",
      key: "action",
      width: 180,
      align: "center",
      render: (version: IVersion) => (
        <div className="flex items-center justify-center">
          <div
            onClick={() => {
              if (!isDownloading) {
                download(version?.id);
              }
            }}
            className="table__action__btn table__action__btn--download"
          >
            {isDownloading &&
              downloadingVersionId.current === version?.id ? (
              <LoadingOutlined className="spinner" />
            ) : (
              <>
                <MdOutlineFileDownload className="text-white text-xl mr-1" />
                Download
              </>
            )}
          </div>
        </div>
      ),
    },
  ];
